module.exports = __webpack_public_path__ + "static/media/monthlyPLAnalaysis_ja_dark_large.836ea792.png";